//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Group = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Group"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21705_3232)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.5 0C0.671573 0 0 0.671573 0 1.5V5.5C0 6.32843 0.671573 7 1.5 7H5.5C6.32843 7 7 6.32843 7 5.5V1.5C7 0.671573 6.32843 0 5.5 0H1.5ZM1.5 9C0.671573 9 0 9.67157 0 10.5V14.5C0 15.3284 0.671573 16 1.5 16H5.5C6.32843 16 7 15.3284 7 14.5V10.5C7 9.67157 6.32843 9 5.5 9H1.5ZM9 10.5C9 9.67157 9.67157 9 10.5 9H14.5C15.3284 9 16 9.67157 16 10.5V14.5C16 15.3284 15.3284 16 14.5 16H10.5C9.67157 16 9 15.3284 9 14.5V10.5ZM10.5 0C9.67157 0 9 0.671573 9 1.5V5.5C9 6.32843 9.67157 7 10.5 7H14.5C15.3284 7 16 6.32843 16 5.5V1.5C16 0.671573 15.3284 0 14.5 0H10.5Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21705_3232">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
